// extracted by mini-css-extract-plugin
export default {"collectionListWrap":"ListPosts_collectionListWrap__v06hd","collectionList":"ListPosts_collectionList__s9Agv"};